import React, { FunctionComponent, ReactNode } from 'react';
import classes from './PageLayoutContentText.module.css';

export const PageLayoutContentText: FunctionComponent<{
  children: ReactNode;
}> = ({ children }) => {
  return <div className={`${classes.content}`}>{children}</div>;
};
